var Chart = require("chart.js");

$(document).ready(function (e) {

    if ($(".e-pie-graph").length > 0) {
      
        var chart_loader = $(".e-pie-graph").find(".loader");
        var piegraph_chart = $(".e-pie-graph__canvas canvas");
        var piegraph_chart_data = {};
        var piegraph_chart_object = null;

        if (piegraph_chart.length > 0) {

            // get chart data
            piegraph_chart_data = JSON.parse(piegraph_chart.attr("data-json"));

            // create chart
            piegraph_chart_object = new Chart(piegraph_chart, {
                type: "pie",
                options: {
                legend: {
                    position: "left",
                    labels: {
                        fontFamily: "Montserrat",
                        fontSize: 15,
                        fontColor: "#000",
                        usePointStyle: true,
                        padding: 20,
                    },
                },
                onResize: function (chart, size) {
                    if (size.width <= 450) {
                        chart.options.legend.position = "bottom";
                        chart.options.maintainAspectRatio = false;
                        chart.canvas.parentNode.style.height = "220px";
                    } else {
                        chart.options.legend.position = "left";
                        chart.options.maintainAspectRatio = true;
                        chart.canvas.parentNode.style.height = "auto";
                    }
                },
                },
                data: {
                labels: piegraph_chart_data.Labels,
                datasets: [
                    {
                        data: piegraph_chart_data.Values,
                        backgroundColor: piegraph_chart_data.Colours,
                    },
                ],
                },
            });

            if (piegraph_chart.outerWidth() <= 450) {
                piegraph_chart_object.options.legend.position = "bottom";
                piegraph_chart_object.options.maintainAspectRatio = false;
                piegraph_chart_object.canvas.parentNode.style.height = "220px";
            }

            chart_loader.hide();
        }
    }
});
